<template>
  <svg
    :class="'c-system-icon c-system-icon--status-'+statusCode"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="c-system-icon__radio-large"
      d="M1 3.56A2.56 2.56 0 0 1 3.56 1 43.44 43.44 0 0 1 47 44.44a2.56 2.56 0 0 1-5.11 0A38.33 38.33 0 0 0 3.56 6.11 2.56 2.56 0 0 1 1 3.56z"
    ></path>
    <path
      class="c-system-icon__radio-small"
      d="M1 21.44a2.56 2.56 0 0 1 2.56-2.55A25.56 25.56 0 0 1 29.1 44.44a2.56 2.56 0 1 1-5.11 0A20.44 20.44 0 0 0 3.56 24 2.56 2.56 0 0 1 1 21.44z"
    ></path>
    <path
      class="c-system-icon__point"
      d="M6.11 36.78a5.11 5.11 0 1 0 0 10.22 5.11 5.11 0 0 0 0-10.22z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "system-icon",
  props: ["system"],
  computed: {
    statusCode() {
      switch (this.system.value) {
        case 1:
          //online
          return "green";
          break;
        case 0:
          //offline
          return "danger";
          break;
        default:
          //issue
          return "amber";
          break;
      }
    }
  }
};
</script>

<style lang="scss">
.c-system-icon {
  width: 18px;
  height: 18px;

  fill: #c1c1c1;

  &--status-green {
    fill: #16a446;
  }

  &--status-amber {
    fill: #e3793b;
  }

  &--status-danger {
    fill: $colour-nhs-emergency-red;
  }
}
</style>
